var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExportData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 1.5H11.9C8.25966 1.5 6.43949 1.5 5.04906 2.20846C3.82601 2.83163 2.83163 3.82601 2.20846 5.04906C1.5 6.43949 1.5 8.25966 1.5 11.9V30.1C1.5 33.7403 1.5 35.5605 2.20846 36.9509C2.83163 38.174 3.82601 39.1684 5.04906 39.7915C6.43949 40.5 8.25966 40.5 11.9 40.5H30.1C33.7403 40.5 35.5605 40.5 36.9509 39.7915C38.174 39.1684 39.1684 38.174 39.7915 36.9509C40.5 35.5605 40.5 33.7403 40.5 30.1V25.3333M40.5 14.5L40.4999 1.50002M40.4999 1.50002H27.5M40.4999 1.50002L21 21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExportData);
export default __webpack_public_path__ + "static/media/IconExportData.c795b05778054c2310e0f27cdd63ac3c.svg";
export { ForwardRef as ReactComponent };